import { render, staticRenderFns } from "./integralMall.vue?vue&type=template&id=18d4103c&scoped=true"
import script from "./integralMall.vue?vue&type=script&lang=js"
export * from "./integralMall.vue?vue&type=script&lang=js"
import style0 from "./integralMall.vue?vue&type=style&index=0&id=18d4103c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4103c",
  null
  
)

export default component.exports